<template>
  <div class="content-item" style="text-align: center">
    <h2 class="heading">Download and Print the "What To Say Cards"</h2>
    <p class="text">
      Good job, yet again! We are so close to wrapping the first steps up. While your waiting on hearing from the designer please download the "What to Say Cards" and print them double sided on heavy
      card stock. You can even laminate them! These will go into your people's wallets to help them know what to say. Please download the file now and then go to the next step.
    </p>
    <a-button style="background: #1c84c6; border: none" type="primary">
      <a href="https://truelifeorg.s3.amazonaws.com/What+to+Say+Card.pdf" download="file" target="_blank">
        <span><a-icon type="download" />&nbsp;Download PDF </span>
      </a>
    </a-button>
  </div>
</template>

<script>
import { get } from 'lodash';
export default {
  name: 'Step5',
  props: {
    value: {
      type: Object,
    },
    source: {
      type: Object,
    },
  },
  computed: {
    backCards() {
      return get(this.source, 'back', []);
    },
  },
  data() {
    return {
      selected: {},
    };
  },
  methods: {
    downloadPdf() {
      alert();
    },
  },
};
</script>
